﻿import { create } from "zustand";

const defaultChannels = {};

export const useNotificationPreferenceStore = create((set) => ({
    preferences: { channels: defaultChannels },
    isLoading: false,

    setPreferences: (preferences) => set({ preferences }),
    setLoading: (isLoading) => set({ isLoading }),
}));
